<template>
  <!-- API Key Card -->
  <div class="uk-card uk-card-body uk-card-primary uk-border-rounded mp-section-console">
    <div class="uk-grid uk-child-width-1-2@m uk-child-width-1-1 uk-flex uk-flex-middle uk-grid-small" uk-grid>
      <div>
        <h4><i class="far fa-key"></i> Authorisation</h4>
        <p>All endpoints require an API key for authorisation.</p>
      </div>
      <div>
        <label class="uk-form-label">API Key</label>
        <div class="uk-form-controls">
          <input class="uk-input" type="text" placeholder="Enter your RadioPlayer WRAPI Key..." :value="apiKey" @input="$emit('update:apiKey', $event.target.value)" required>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CardApiKey",
    props: ["apiKey"]
  }
</script>
